import React, { Component } from "react";
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import close from "../../../img/close.svg"
import "./style.scss";

export class AnimationSequence extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getNext = () => {
    if (
      this.props.data.hasOwnProperty("pIndex") &&
      this.props.data.hasOwnProperty("tIndex")
    ) {

      if(this.props.taskPages[this.props.data.pIndex].tasks.length > (this.props.data.tIndex + 1)){
        this.props.setModal({
          display: true,
          type: this.props.taskPages[this.props.data.pIndex].tasks[this.props.data.tIndex + 1].modal.type,
          size: "lg",
          connect: -1,
          data: this.props.taskPages[this.props.data.pIndex].tasks[this.props.data.tIndex + 1].modal,
        });
      } else {
        this.props.setModal({
          display: true,
          type: this.props.taskPages[this.props.data.pIndex + 1].tasks[0].modal.type,
          size: "lg",
          connect: -1,
          data: this.props.taskPages[this.props.data.pIndex + 1].tasks[0].modal,
        });
      }
    }
  };

  finishStep = () => {
    switch (this.props.type) {
      case "DEPOSIT_SOLUTION":
        this.depositSolution();
        break;
      case "LOAD_GELBOX_SOLUTION":
        this.loadGelBoxSolution();
        this.getNext();
        break;
      case "PREPARE_GELBOX":
        this.prepareGelBox();
        this.getNext();
        break;
      case "RUN_GELBOX":
        this.runGelBox();
        this.getNext();
        break;
      case "VISUALISE_GEL":
        this.visualizeGel();
        this.getNext();
        break;
      case "PIPETTE_PLUNGER":
        this.pipettePlunger();
        break;
      case "PUT_ON_PPE":
        this.putOnPPE();
        break;
      case "THERMOCYCLER_RUN":
        this.runThermocycler();
        this.getNext();
        break;
      default:
      // code block
    }
  };

  getAltText = () => {
    let altText;

    switch (this.props.type) {
      case "DEPOSIT_SOLUTION":
        altText = "Pipetting the samples";
        break;
      case "LOAD_GELBOX_SOLUTION":
        altText = "A gel with 5 wells is in the gel electrophoresis box. A micropipette is used to add samples to each well, one at a time. The DNA ladder is added to the first well. The 3 controls are added to wells 2 through 4, and the sample is added to the 5th well.";
        break;
      case "PREPARE_GELBOX":
        altText = "A gel is placed in the gel electrophoresis box and is covered with buffer solution.";
        break;
      case "RUN_GELBOX":
        altText = "The gel electrophoresis box is plugged into a power source. When the power source is turned on, it applies 150 volts to the gel. The DNA in the wells move from the top of the gel to the bottom. Once the loading dye reaches the bottom of the gel, the power source is turned off.";
        break;
      case "VISUALISE_GEL":
        altText = "Visualizing the gel";
        break;
      case "PIPETTE_PLUNGER":
        altText = "Mixing the sample";
        break;
      case "PUT_ON_PPE":
        altText = "An animation of a person putting on a lab coat, gloves, and safety goggles.";
        break;
      case "THERMOCYCLER_RUN":
        altText = "An animation of the PCR cycle. The animation cycles through the 3 steps of PCR repeatedly.";
        break;
      default:
      // code block
    }

    return altText;
  };

  getTitle = () => {
    let title;

    switch (this.props.type) {
      case "DEPOSIT_SOLUTION":
        title = "Pipetting the samples";
        break;
      case "LOAD_GELBOX_SOLUTION":
        title = "Loading the samples";
        break;
      case "PREPARE_GELBOX":
        title = "Preparing the gel electrophoresis box";
        break;
      case "RUN_GELBOX":
        title = "Running the samples";
        break;
      case "VISUALISE_GEL":
        title = "Visualizing the gel";
        break;
      case "PIPETTE_PLUNGER":
        title = "Mixing the sample";
        break;
      case "PUT_ON_PPE":
        title = "Putting on PPE";
        break;
      case "THERMOCYCLER_RUN":
        title = "Running the thermocycler";
        break;
      default:
      // code block
    }

    return title;
  };

  depositSolution = () => {
    let rowMap = {
      "Control 1 (normal GENE X, positive control)": "Control 1 Thermocycler",
      "Control 2 (mutated GENE X, positive control)": "Control 2 Thermocycler",
      "Control 3 (no template, negative control)": "Control 3 Thermocycler",
      "Control 4 (prokaryotic control DNA, negative control)":
        "Control 4 Thermocycler",
      "Control 1 (Positive Control)": "Control 1 Thermocycler",
      "Control 2 (Positive Control)": "Control 2 Thermocycler",
      "Control 3 (Negative Control)": "Control 3 Thermocycler",
      "Control 4 (DNA Negative Control)": "Control 4 Thermocycler",
    };

    let solMap = {
      "1 μl extracted human DNA": "Extracted Human DNA",
      "1 μl normal GENE X control DNA": "Normal GENE X Control DNA",
      "1 µL mutated GENE X control DNA": "Shorter GENE X Control DNA",
      "1 μl DNase free water": "DNase Free Water",
      "1 μl prokaryotic control DNA": "Prokaryotic Control DNA",
    };

    this.props.tableData.data.forEach((row, rowIndex) => {
      if (rowIndex !== 0) {
        let itemProps = this.props.solutions.find(
          (solution) => solution.type === rowMap[row[0]]
        );
        let solutions = [];

        // Set the template DNA based off the Protocol Table
        if (row[1] !== null) {
          solutions.push({
            [solMap[row[1]]]: 1,
          });
        }

        // Set the Master Mix volume
        if (row[2] !== null) {
          let solutionsArr = Object.keys(this.props.solutions[6].solutions);
          let totalVol = this.props.solutions[6].volume;

          // Master Mix is ID 7
          solutionsArr.forEach((solution, index) => {
            let solutionVolume = this.props.solutions[6].solutions[solution];

            solutions.push({
              [solution]: row[2] * (solutionVolume / totalVol),
            });
          });
        }

        // Set the dH20 volume
        // if(row[4] !== null){
        //   solutions.push({
        //     "DNase Free Water": parseFloat(row[4], 10)
        //   })
        // }

        if (
          typeof itemProps !== "undefined" &&
          Object.keys(solutions).length > 0
        ) {
          this.props.incSolution({
            id: itemProps.id,
            solutions: solutions,
            fragments: {},
          });
        }
      }
    });

    // this.props.decSolution({
    //   id: solutionID,
    //   type: solutionObj.type,
    //   amount: volume
    // });

    this.props.showModal({
      display: false,
    });
  };
  loadGelBoxSolution = () => {
    this.props.loadDNALadder(true);
    this.props.showModal({
      display: false,
    });
  };
  prepareGelBox = () => {
    this.props.prepareGelBox(true);
    this.props.showModal({
      display: false,
    });
  };
  runGelBox = () => {
    this.props.runGel(true);
    this.props.showModal({
      display: false,
    });
  };
  visualizeGel = () => {
    this.props.visualizeGel(true);
    this.props.showModal({
      display: false,
    });
  };
  pipettePlunger = () => {
    this.props.setSolutionMixed({
      id: this.props.id,
      mixed: true,
    });
    this.props.showModal({
      display: false,
    });
  };
  putOnPPE = () => {
    this.props.putOnPPE(true);
    this.props.showModal({
      display: false,
    });
  };
  runThermocycler = () => {
    this.props.runThermocycler(true);
    this.props.showModal({
      display: false,
    });
  };

  render() {
    return (
      <>
      <div
        aria-label="Close Button"
        tabIndex={0}
        className={
          this.props.type === "UNDO" &&
          this.props.size === "sm"
            ? "close-sm"
            : "close"
        }

        onKeyDown={e => {
          if (e.keyCode === 13 || e.keyCode === 32) this.finishStep(e);
        }}
        onClick={() => this.finishStep()}
      >
        <p>
          Close{" "}
          <img
            style={{
              display: "inline-block",
              top: "3px",
              position: "relative"
            }}
            src={close}
            alt="Close button"
          />
        </p>
      </div>
      <div
        className="modal-section deposit-solution"
        style={{
          width: "calc(100% - 0px)",
          //height: "650px",
          margin: "auto",
        }}
      >
        <div className="modal-header">
          <h2>{this.getTitle()}</h2>
        </div>

        <div className="modal-body">
          <div className="modal-inner" aria-label={this.getAltText()}>
            <Player
              //alt='content-item'
              //className={props.className}
              autoplay
              controls
              src={this.props.animation}
            >
              <Controls visible={true} buttons={["play", "stop", "repeat"]} />
            </Player>
          </div>
        </div>

        <div className="modal-footer">
          <div
            style={{
              justifySelf: "flex-start",
              marginRight: "auto",
            }}
          >
            <p>
              Hit the "{(this.props.data.hasOwnProperty("pIndex") &&
                this.props.data.hasOwnProperty("tIndex")) ? "Next" : "Finish"} step"
              button when you want to move on.
            </p>
          </div>
          <button
            aria-label="Done"
            tabIndex={this.props.tab}
            className="modal-btn-primary"
            onClick={() => this.finishStep()}
          >
            {(this.props.data.hasOwnProperty("pIndex") &&
              this.props.data.hasOwnProperty("tIndex")) ? "Next" : "Finish"} step
          </button>
        </div>
      </div>
      </>
    );
  }
}
